import logger from "src/utils/logger";

export const checkCameraDevices = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter(device => device.kind === 'videoinput');
    return videoDevices;
};

export const getCameraPermissionStatus = async () => {
    if (!navigator.permissions || !navigator.permissions.query) {
        logger.warn("Permissions API not supported on browser.");
        return null;
    }

    try {
        const permissionStatus = await navigator.permissions.query({ name: "camera" });
        return permissionStatus.state;
    } catch (err) {
        logger.error("Permission query error:", err);
        return null;
    }
};

export const hasCamera = async () => {
    const videoDevices = await checkCameraDevices();
    return videoDevices.length > 0;
};

